import 'whatwg-fetch';
import Swal from 'sweetalert2';
import i18n from '../../app/i18n';

const Fetcher = {};
const authenticationToken = import.meta.env.VITE_INTERNAL_PARTNER_API_TOKEN;

Fetcher.get = (path, cb) =>
  fetch(path, {
    headers: {
      Authorization: authenticationToken,
    },
  })
    .then(resp => resp.json())
    .then(response => cb(response));

Fetcher.xmlHttpRequest = opts => {
  const method = opts.method || 'POST';
  const token = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute('content');

  return fetch(opts.path, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': token,
      'Content-Type': 'application/json',
      Authorization: authenticationToken,
    },
    body: JSON.stringify(opts.params),
    method,
    credentials: 'same-origin',
  })
    .then(resp => {
      if (!resp.ok) throw resp;

      return resp.json();
    })
    .then(response =>
      Object.prototype.hasOwnProperty.call(opts, 'success')
        ? opts.success(response)
        : response,
    )
    .catch(err => {
      if (err.status === 401) {
        Swal.fire({
          type: 'error',
          title: 'Authentication Error',
          text: `${i18n.t('accountSettings:passwordForm.unauthorized')}`,
          showConfirmButton: false,
        });
        setTimeout(
          () => document.location.replace(document.location.origin),
          3000,
        );
      } else if (opts.err) {
        opts.err(err);
      } else {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      throw err;
    });
};

export default Fetcher;
